import React from 'react';
import { getFieldValue } from '../../../contentful/mappers';
import Button from '../../Button/Button';
import './Custom.css';

// Component registry for individual components that can be used in Custom sections
const componentRegistry = {
  buttonComponent: Button,
};

function Custom({ data }) {
  if (!data) return null;

  const components = getFieldValue(data, 'components') || [];
  const bgTheme = getFieldValue(data, 'bgTheme') || 'light';
  const className = getFieldValue(data, 'className') || '';
  const textAlign = getFieldValue(data, 'textAlign') || getFieldValue(data, 'align') || 'left';

  if (!Array.isArray(components) || components.length === 0) {
    return null;
  }

  const sectionClass = `custom-section custom-section-${bgTheme} ${className}`.trim();
  const contentClass = `custom-content custom-content-${textAlign}`.trim();

  return (
    <section className={sectionClass}>
      <div className="container">
        <div className={contentClass}>
          {components.map((component, index) => {
            const componentType = getFieldValue(component, 'componentType');
            const Component = componentRegistry[componentType];
            
            if (!Component) {
              console.warn(`Unknown component type in Custom section: ${componentType}`);
              return null;
            }
            
            // For Button component, extract props from data
            if (componentType === 'buttonComponent' || componentType === 'button') {
              const label = getFieldValue(component, 'label') || getFieldValue(component, 'text');
              const href = getFieldValue(component, 'href') || getFieldValue(component, 'url');
              const variant = getFieldValue(component, 'variant') || 'primary';
              const className = getFieldValue(component, 'className') || '';
              
              if (!label) return null;
              
              return (
                <Component 
                  key={component.sys?.id || index}
                  href={href}
                  variant={variant}
                  className={className.trim()}
                >
                  {label}
                </Component>
              );
            }
            
            // For other component types (when added later)
            return (
              <Component 
                key={component.sys?.id || index} 
                data={component} 
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Custom;

